<template>
  <div>
    <el-dialog
      :title="title"
      :width="width"
      v-if="dialogFormVisible"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :before-close="OnCancel"
      :destroy-on-close="true"
    >
      <slot></slot>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ZjDialog",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: "组件标题",
    },
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "300px",
    },
  },
  methods: {
    OnCancel() {
      this.$emit("clickCancel", {});
    },
  },
};
</script>